import { graphql } from '@generated/gql';

/**
 * `archived: false` is the answer for a household that had no live copy, which
 * is a state of affairs rather than a failure. Requires `write:model_portfolios`.
 */
export const ARCHIVE_HOUSEHOLD_COPY = graphql(/** GraphQL */ `
  mutation useArchiveHouseholdCopyArchiveEntityBoundModel(
    $input: ArchiveEntityBoundModelInput!
  ) {
    archiveEntityBoundModel(input: $input) {
      archived
      modelPortfolio {
        id
        state
      }
    }
  }
`);
